import { useLocation, useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";
const Breadcrumb = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;

  const PARENT_MAP = {
    "/nyafaz-salon/add-product": "/nyafaz-salon/productlist",
    "/nyafaz-salon/edit-product": "/nyafaz-salon/productlist",
    "/nyafaz-salon/view-product": "/nyafaz-salon/productlist",
    "/nyafaz-salon/product/": "/nyafaz-salon/productlist",
    "/nyafaz-salon/add-plan": "/nyafaz-salon/users",
    "/nyafaz-salon/subscriptions/": "/nyafaz-salon/subscriptions",
    "/nyafaz-salon/invoice/": "/nyafaz-salon/invoices",
    "/nyafaz-salon/payments/": "/nyafaz-salon/payment-requests",
    "/nyafaz-salon/add-service": "/nyafaz-salon/servicelist",
    "/nyafaz-salon/edit-service": "/nyafaz-salon/servicelist",
    "/nyafaz-salon/view-service": "/nyafaz-salon/servicelist",
    "/nyafaz-salon/service/": "/nyafaz-salon/servicelist",
  };

  const LABELS_MAP = {
    "dashboard": "Dashboard",
    "ib-dashboard": "Dashboard",
    "productlist": "Product list",
    "add-product": "Add Product",
    "edit-product": "Edit Product",
    "view-product": "View Product",
    "users": "Users",
    "add-plan": "Add Plan",
    "organization": "Organizations",
    "edit-profile": "Edit Profile",
    "settings": "Settings",
    "invoices": "Invoices",
    "subscriptions": "Subscriptions",
    "payment-requests": "Payments",
    "invoice": "Invoice details",
    "payments": "Payment details",
  };

  const getLabel = (segment) => {
    if (LABELS_MAP[segment]) return LABELS_MAP[segment];
    return segment.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  };

  // Find the parent route entry
  const parentEntry = Object.entries(PARENT_MAP).find(([key]) => path.startsWith(key));

  // If current path is NOT a sub-page (not in PARENT_MAP), hide the breadcrumb entirely
  if (!parentEntry) return null;

  const parentPath = location.state?.from || parentEntry[1];
  const parentLabel = getLabel(parentPath.split("/").pop());
  const currentSegment = path.split("/").filter(Boolean).pop();

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={() => navigate(parentPath)}
        className="p-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-full transition-all"
        title={`Back to ${parentLabel}`}
      >
        <IoArrowBack size={20} />
      </button>

      <span className="text-gray-300">|</span>

      <span className="font-semibold text-gray-800 text-sm">
        {getLabel(currentSegment)}
      </span>
    </div>
  );
};

export default Breadcrumb;
